export default __webpack_public_path__ + "static/media/hawklayer2.950f1a24.png";